//
// Copyright (c) 2020 Astute Global, Inc.
//

define([
  "jquery",
  "marionette",
  "messaging/messenger",
  "./template/rejectTopicEditModalTemplate.html",
], function ($, Marionette, Messenger, RejectTopicEditModalTemplate) {
  "use strict";

  const RejectTopicEditModalView = {};

  RejectTopicEditModalView.view = Marionette.ItemView.extend({
    template: RejectTopicEditModalTemplate,
    triggers: {
      "click .cancel-button": "cancel",
      "click .send-response-button": "sendResponse",
    },
    clearErrors: function () {
      $(".reject-topic-edit-response-error", this.$el).html("");
    },
    getResponse: function () {
      return $(".reject-topic-edit-response", this.$el).val();
    },
    responseError: function (message) {
      $(".reject-topic-edit-response-error", this.$el)
        .html('<h5 class="error-message">' + message + "</h5>")
        .hide()
        .fadeIn();
    },
  });

  return RejectTopicEditModalView;
});
